const STORAGE_KEY = 'kingsmith.pat'

/**
 * The PAT lives in localStorage. With no backend there is nowhere safer to put it;
 * the mitigations are a strict CSP (connect-src is pinned to api.github.com), no
 * third-party scripts, and never rendering quest text as HTML. The token is
 * fine-grained and scoped to one private repo whose full history is in git, so the
 * blast radius is recoverable quest data.
 */
export function loadToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function saveToken(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, token.trim())
  } catch {
    /* private browsing — the session still works, it just won't be remembered */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* nothing to do */
  }
}
